



















import Vue from "vue";

export default Vue.extend({
  name: "App",
  data() {
    return {
      title: ""
    };
  },
  computed: {
    layout() {
      return window.location.href.indexOf("seller") > -1
        ? "seller-layout"
        : "default-layout";
    }
  },
  mounted() {
    if (localStorage.locale == "ar") {
      this.title = "مثابر";
      document.title = this.title;
    } else {
      this.title = "Mothaber";
      document.title = this.title;
    }
  }
});
